/**
 * Handle get/set user token
 * @type {{get: (function()), set: (function(*=))}}
 */
export const USER_TOKEN = {
  get: () => localStorage?.getItem('userToken'),
  set: (newValue) => {
    localStorage?.setItem('userToken', `Bearer ${newValue}`);
  },
  delete: () => localStorage?.removeItem('userToken'),
};

export const SELECTED_CENTRES = {
  get: () => localStorage?.getItem('selectedCentres'),
  set: (val) => {
    localStorage?.setItem('selectedCentres', val);
  },
  delete: () => localStorage?.removeItem('selectedCentres'),
};

export const TEMP_USER_TOKEN = {
  get: () => localStorage?.getItem('tempUserToken'),
  set: (newValue) => {
    localStorage?.setItem('tempUserToken', newValue);
  },
  delete: () => localStorage?.removeItem('tempUserToken'),
};

export const PREVIOUS_ROLEID = {
  get: () => localStorage?.getItem('previousRoleid'),
  set: (newValue) => {
    localStorage?.setItem('previousRoleid', newValue);
  },
  delete: () => localStorage?.removeItem('previousRoleid'),
};

export const LANGUAGE = {
  get: () => localStorage.getItem('lang'),
  set: (newValue) => {
    localStorage.setItem('lang', newValue);
  },
  delete: () => localStorage.removeItem('lang'),
};

export const USER_VIEW_MODE = {
  get: () => localStorage?.getItem('userViewMode'),
  set: (newValue) => {
    localStorage?.setItem('userViewMode', newValue);
  },
  delete: () => localStorage?.removeItem('userViewMode'),
};

export const ARR_USER_ROLES = {
  get: () => localStorage?.getItem('userRoles'),
  set: (newValue) => {
    localStorage?.setItem('userRoles', newValue);
  },
  delete: () => localStorage?.removeItem('userRoles'),
};

export const SESSION_EXPIRY = {
  get: () => localStorage?.getItem('sessionExpiry'),
  set: (value) => localStorage?.setItem('sessionExpiry', String(value)),
  delete: () => localStorage?.removeItem('sessionExpiry'),
};

export const THEME_MODE = {
  get: () =>
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('lmsThemeMode')
      : null,
  set: (value) => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('lmsThemeMode', String(value));
    }
  },
  delete: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('lmsThemeMode');
    }
  },
};
